/* 
  Left 메뉴 리스트
    no : 메뉴 순써 숫자
    name: 이름
    eName: 영어이름
    link: 링크 
    sub: 서브메뉴 여부
    permission: 접근 권한
*/
export const LeftMenuList = [
  {
    no: 1,
    name: "대시보드",
    eName: "dashboard",
    link: "/",
    sub: null,
    permission: null,
  },
  {
    no: 2,
    name: "광고관리",
    eName: "ad",
    link: null,
    open: true,
    permission: null,
    sub: [
      {
        sNo: 0,
        name: "광고현황",
        link: "/ad",
        eName: "",
        permission: null,
      },
      {
        sNo: 1,
        name: "소재등록",
        link: "/ad/add",
        eName: "add",
        permission: null,
      },
    ],
  },
  {
    no: 3,
    name: "광고주관리",
    eName: "advertiser",
    link: null,
    open: true,
    permission: null,
    sub: [
      {
        sNo: 0,
        name: "광고주등록",
        link: "/advertiser",
        eName: "",
        permission: null,
      },
      {
        sNo: 1,
        name: "광고주정보",
        link: "/advertiser/info",
        eName: "info",
        permission: null,
      },
    ],
  },
];
